<template>
  <div class="page_custEmp">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.name" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" size="small">
              <el-input v-model="listQuery.tel" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectId" placeholder="" size="small" clearable filterable style="width:180px" v-if="activeName=='待面试' || activeName=='待入职'">
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
              <el-select v-model="listQuery.projectName" placeholder="" size="small" clearable filterable style="width:180px" v-if="activeName=='在职' || activeName=='离职'">
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="small">
              <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
                <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
              </el-tooltip>
            </el-form-item>
            <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-left: 15px;">搜索</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item :label="activeName=='待面试' ? '面试时间' : activeName=='待入职' ? '通过时间' : activeName=='在职' ? '入职时间' : '离职时间'" size="small">
            <div class="flex">
              <el-date-picker v-model="listQuery.begin" type="date" value-format="yyyy-MM-dd" size="small" style="width:180px">
              </el-date-picker>
              <div style="margin: 0 10px;"> ~ </div>
              <el-date-picker v-model="listQuery.end" type="date" value-format="yyyy-MM-dd" size="small" style="width:180px">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="待面试" name="待面试"></el-tab-pane>
          <el-tab-pane label="待入职" name="待入职"></el-tab-pane>
          <el-tab-pane label="在职" name="在职"></el-tab-pane>
          <el-tab-pane label="离职" name="离职"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;" class="flex" v-if="activeName=='待面试'">
          <el-button type="success" size="small" @click="handelPass('通过')" v-if="checkPermission(['custEmp_pass'],permissionLists)">通过</el-button>
          <el-button type="danger" size="small" @click="handelPass('未通过')" v-if="checkPermission(['custEmp_notPass'],permissionLists)">未通过</el-button>
          <el-button type="warning" size="small" @click="handelPass('未到面')" v-if="checkPermission(['custEmp_notFace'],permissionLists)">未到面</el-button>
          <el-button type="primary" size="small" :loading="isExping" @click="expList('InterviewExcel')" v-if="checkPermission(['custEmp_expList'],permissionLists)">导出</el-button>
        </div>
        <div style="margin-bottom: 10px;" class="flex" v-if="activeName=='待入职'">
          <el-button type="primary" size="small" @click="entrySign" v-if="checkPermission(['custEmp_entrySign'],permissionLists)">入职预登记</el-button>
          <el-button type="success" size="small" @click="importEntryList" v-if="checkPermission(['custEmp_impEntrySign'],permissionLists)">导入预登记</el-button>
          <!-- <el-button type="warning" size="small" @click="enterSignHandle">电子签约</el-button> -->

          <el-popconfirm :title="'请确认是否删除选中的' + multipleSelection.length + '位人员'" @confirm="delEntry(row)" style="margin: 0 10px;" v-if="checkPermission(['custEmp_del'],permissionLists)">
            <el-button type="danger" slot="reference" size="small" :loading="isDeling">删除</el-button>
          </el-popconfirm>
          <el-button type="primary" size="small" :loading="isExping" @click="expList('WaitEntryExcel')" v-if="checkPermission(['custEmp_expList'],permissionLists)">导出</el-button>
        </div>
        <div style="margin-bottom: 10px;" class="flex" v-if="activeName=='在职'">
          <el-button type="warning" size="small" @click="enterSignHandle" v-if="checkPermission(['custEmp_toEleSigning'],permissionLists)">电子签约</el-button>
          <el-button type="danger" size="small" @click="quitSign" v-if="checkPermission(['custEmp_quitSign'],permissionLists)">离职登记</el-button>
          <el-button type="primary" size="small" :loading="isExping" @click="expList('OnJobExcel')" v-if="checkPermission(['custEmp_expList'],permissionLists)">导出</el-button>
        </div>
        <div style="margin-bottom: 10px;" class="flex" v-if="activeName=='离职'">
          <el-button type="primary" size="small" :loading="isExping" @click="expList('TurnOverExcel')" v-if="checkPermission(['custEmp_expList'],permissionLists)">导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <el-table-column label="序号" key="0" prop="No" min-width="60" fixed="left" align="center">
          </el-table-column>
          <el-table-column label="客户名称（简称）" key="1" prop="ShortName" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='待入职'">
          </el-table-column>
          <el-table-column label="项目名称" prop="ProjectName" key="2" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName!='待面试'">
          </el-table-column>
          <el-table-column label="岗位" prop="JobName" key="2.1" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName!='待面试'">
          </el-table-column>
          <el-table-column label="姓名" key="3" prop="Name" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="身份证号码" key="4" prop="IdCard" min-width="160" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="联系方式" key="5" prop="Tel" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="性别" key="6" prop="Sex" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="年龄" key="7" prop="Age" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="参保状态" key="8" prop="InsureState" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="合同/协议" key="9" prop="ContractType" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="签约主体" key="10" prop="CompanyName" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="签约时间" key="11" prop="ContractSignTime" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="合同开始时间" key="12" prop="ContractBeginTime" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="合同结束时间" key="13" prop="ContractEndTime" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="是否签约" key="14" prop="IsSign" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='待入职'">
          </el-table-column>
          <el-table-column label="是否黑名单" key="15" prop="IsBlack" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName!='待面试'">
          </el-table-column>
          <el-table-column label="标签" key="16" prop="Tag" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName!='待面试'">
          </el-table-column>
          <el-table-column label="面试通过登记时间" key="17" prop="InterviewPassTime" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='待入职'">
          </el-table-column>
          <el-table-column label="户籍地址" key="18" prop="InterviewAddress" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName!='待面试'">
          </el-table-column>
          <el-table-column label="面试项目" key="19" prop="ProjectName" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='待面试'">
          </el-table-column>
          <el-table-column label="面试岗位" key="20" prop="JobName" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='待面试'">
          </el-table-column>
          <el-table-column label="面试时间" key="21" prop="InterviewTime" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='待面试'">
            <template slot-scope="{row}">{{ row.InterviewTime ?row.InterviewTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <el-table-column label="面试地点" key="22" prop="InterviewAddress" min-width="160" :show-overflow-tooltip="true" align="center" v-if="activeName=='待面试' ||activeName=='待入职' ">
          </el-table-column>
          <el-table-column label="创建时间" key="23" prop="CreateTime" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName!='在职'">
          </el-table-column>
          <el-table-column label="创建时间" key="23" prop="EntryTime" min-width="140" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
          </el-table-column>
          <el-table-column label="身份证正面照片" key="24" prop="FrontCardIdUrl" min-width="120" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
            <template slot-scope="{row}">
              <el-image style="width: 50px; height: 30px" :src="$store.state.EMP.imgPath + row.FrontCardIdUrl" :preview-src-list="[$store.state.EMP.imgPath + row.FrontCardIdUrl]" v-if="row.FrontCardIdUrl">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="身份证反面照片" key="25" prop="VersoCardIdUrl" min-width="120" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
            <template slot-scope="{row}">
              <el-image style="width: 50px; height: 30px" :src="$store.state.EMP.imgPath + row.VersoCardIdUrl" :preview-src-list="[$store.state.EMP.imgPath + row.VersoCardIdUrl]" v-if="row.VersoCardIdUrl">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="银行卡照片" key="26" prop="ContractSignTime" min-width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='在职'">
            <template slot-scope="{row}">
              <el-image style="width: 50px; height: 30px" :src="$store.state.EMP.imgPath + row.BankCardUrl" :preview-src-list="[$store.state.EMP.imgPath + row.BankCardUrl]" v-if="row.BankCardUrl">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="备注" key="27" prop="Remark" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center" v-if="activeName!='待面试'" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" v-if="activeName=='待入职' && checkPermission(['custEmp_submit'],permissionLists)" @click="entryHandel(row)">提交</el-button>
                <el-button type="text" v-if="(activeName=='在职' || activeName=='离职') && checkPermission(['custEmp_tag'],permissionLists)" @click="tagging(row)">打标签</el-button>
                <el-button type="text" v-if="activeName=='离职' && row.IsBlack!='是' && checkPermission(['custEmp_black'],permissionLists)" @click="black(row)">拉黑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.currpage" :page-size="Number(listQuery.pagecount)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 待面试操作 -->
    <el-dialog :title="'确认' + type" :visible.sync="showPass" width="800px">
      <el-table :data="multipleSelection" class="doc_table" v-loading="loading" style="width:100%">
        <el-table-column label="序号" prop="No" min-width="60" align="center">
        </el-table-column>
        <el-table-column label="姓名" prop="Name" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="联系方式" prop="Tel" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="项目" prop="ProjectName" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="岗位" prop="JobName" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="预计到岗时间 " min-width="160" align="center" v-if="type=='通过'">
          <template slot-scope="{$index}">
            <el-date-picker v-model="handelList[$index].DutyTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="不通过原因" min-width="160" align="center" v-if="type=='未通过'">
          <template slot-scope="{$index}">
            <el-input v-model="handelList[$index].StrRemark" size="small" clearable style="width:140px"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="未到场原因" min-width="160" align="center" v-if="type=='未到面'">
          <template slot-scope="{$index}">
            <el-input v-model="handelList[$index].StrRemark" size="small" clearable style="width:140px"></el-input>
          </template>
        </el-table-column>

      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPass = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmPass" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 入职预登记 -->
    <el-dialog title="入职预登记" :visible.sync="showEntrySign" width="1000px">
      <el-form :inline="true" :rules="entryRules" ref="enterResumeForm" :model="entryForm" class="e_form_box" label-width="115px">
        <el-form-item label="身份证姓名:" prop="StrEmpName">
          <el-input v-model="entryForm.StrEmpName" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号:" prop="StrIdCard">
          <el-input v-model="entryForm.StrIdCard" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="联系方式:" prop="StrPhoneNum">
          <div class="e_line01">
            <el-input v-model="entryForm.StrPhoneNum" size="small" clearable style="width: 180px;"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="用工日期:" prop="DtEntryBdate">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="entryForm.DtEntryBdate" type="date" placeholder="选择日期" style="width: 180px;">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="项目:" prop="StrObjName">
          <el-select v-model="entryForm.StrObjName" size="small" filterable clearable placeholder="" style="width: 180px;" @change="proSearChange">
            <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门:" prop="StrDepName">
          <el-input v-model="entryForm.StrDepName" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="岗位:" prop="StrJobInf">
          <el-select v-model="entryForm.StrJobInf" filterable clearable size="small" placeholder="" style="width: 180px;">
            <el-option v-for="(item, index) in jobList" :key="index" :label="item.CustomerJobName" :value="item.CustomerJobName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌:" prop="StrPolitical">
          <el-select v-model="entryForm.StrPolitical" placeholder="" size="small" clearable style="width: 180px;">
            <el-option v-for="item in politicsList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证有效期:" prop="DtIcCareEdate">
          <div class="r_flex">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="entryForm.DtIcCareEdate" :disabled="isLongCheck" type="date" placeholder="选择日期" style="width: 130px;"></el-date-picker>
            <el-checkbox v-model="isLongCheck" @change="longChange" style="margin-left: 5px;">长期有效</el-checkbox>
          </div>
        </el-form-item>
        <el-form-item label="民族:" prop="StrNationClass">
          <el-select v-model="entryForm.StrNationClass" filterable placeholder="" size="small" clearable style="width: 180px;">
            <el-option v-for="item in nationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="籍贯:" prop="StrNativePlace">
          <el-input v-model="entryForm.StrNativePlace" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="户籍地址:" prop="StrNativeAddr">
          <el-input v-model="entryForm.StrNativeAddr" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="现住地址:" prop="StrAddr">
          <el-input v-model="entryForm.StrAddr" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="参保种类:" prop="StrInsuranceType">
          <el-input v-model="entryForm.StrInsuranceType" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="参保日期:" prop="DtInsuranceDate">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="entryForm.DtInsuranceDate" type="date" placeholder="选择日期" clearable style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="医保卡号:" prop="StrMedicalCard">
          <el-input v-model="entryForm.StrMedicalCard" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="合同协议类型:" prop="StrContractType">
          <el-select v-model="entryForm.StrContractType" placeholder="" size="small" clearable style="width: 180px;">
            <el-option v-for="item in contractTypeList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同起始时间 :" prop="DtContractBtime">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="entryForm.DtContractBtime" type="date" placeholder="" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同到期时间 :" prop="DtContractTime">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="entryForm.DtContractTime" type="date" placeholder="" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="合同/协议文件 :" prop="attachUrl">

        </el-form-item> -->
        <el-form-item label="是否临时工:" prop="StrOther">
          <el-select filterable v-model="entryForm.StrOther" clearable style="width: 180px;" placeholder="" size="small">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="体检类型:">
          <el-select filterable v-model="entryForm.StrPetype" clearable style="width: 180px;" placeholder="" size="small">
            <el-option label="无要求" value="无要求"></el-option>
            <el-option label="常规体检" value="常规体检"></el-option>
            <el-option label="职业病体检" value="职业病体检"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="体检结果:">
          <el-select filterable v-model="entryForm.StrPeres" clearable style="width: 180px;" placeholder="" size="small">
            <el-option label="正常" value="正常"></el-option>
            <el-option label="异常" value="异常"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行卡号:" prop="StrBankCard">
          <el-input v-model="entryForm.StrBankCard" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="银行:" prop="StrBankName">
          <el-input v-model="entryForm.StrBankName" size="small" clearable style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="合同到期提醒:" prop="StrRemark">
          <el-radio-group v-model="Strremid">
            <el-radio :label="7">提前7天提醒</el-radio>
            <el-radio :label="30">提前30天提醒</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="身份证到期提醒:" prop="StrRemark">
          <el-checkbox true-label="是" false-label="" v-model="entryForm.Strremid60">提前100天提醒</el-checkbox>
        </el-form-item>
        <div>
          <el-form-item label="备注:" prop="StrRemark" class="f_all_width">
            <el-input v-model="entryForm.StrRemark" type="textarea" size="small" rows="1" clearable style="width: 500px;"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEntrySign = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEntrySign" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入入职预登记" :visible.sync="showImport" width="500px">
      <el-form :model="impForm" ref="impForm" :rules="impRules" label-width="100px">
        <el-form-item label="岗位:" prop="jobid">
          <el-select v-model="impForm.jobid" filterable clearable size="small" placeholder="" style="width: 180px;">
            <el-option v-for="(item, index) in allJobList" :key="index" :label="item.CustomerJobName" :value="item.Id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导入Excel" prop="excelUrl">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 电子签约 -->
    <el-dialog title="提交电子签约信息" :visible.sync="showEleInfo" width="1100px">
      <el-form :model="eleForm" :inline="true" :rules="eleRules" ref="eleForm" label-width="135px">
        <el-form-item label="签约模板" prop="tempid">
          <el-select v-model="TempName" placeholder="" clearable filterable size="small" style="width:200px" value-key="TempId" @change="val=>{changeTemp2(val)}">
            <el-option v-for="(item,index) in tempEleList" :key="index" :label="item.TempName" :value="item" size="small"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同/协议类型" prop="ProtocolType">
          <el-select v-model="eleForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="(val)=>{changeCont(val,'eleForm')}" style="width:200px">
            <el-option v-for="(item,index) in contractList" :key="index" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="员工签约主体" prop="ContractSubject">
          <el-select v-model="eleForm.ContractSubject" placeholder="" clearable filterable style="width:200px" @change="(val)=>{changeLeg(val,'eleForm')}" size="small">
            <el-option v-for="(item,index) in legList" :key="index" :value="item.enterpriseName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人" prop="LegalPer">
          <el-input v-model="eleForm.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="RegisterAddress">
          <el-input v-model="eleForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>

        <el-form-item label="工作地点（区域）" prop="WorkSite" v-if="contractType==5 || contractType==6">
          <el-input v-model="eleForm.WorkSite" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="学校全称" prop="SchoolName" v-if="contractType==3 || contractType==9">
          <el-input v-model="eleForm.SchoolName" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="学生专业" prop="StudentMajor" v-if="contractType==9">
          <el-input v-model="eleForm.StudentMajor" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="客户单位全称">
          <el-input v-model="eleForm.list[0].ClientFullName" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType!=9 && contractType!=10 && contractType">
          <el-date-picker type="date" placeholder="" v-model="eleForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同时长（年）' : '协议时长（年）'" v-if="contractType!=9 && contractType!=10 && contractType">
          <el-input type="number" v-model="ContractTime" @blur="getContractEndDate('eleForm')" style="width:200px" size="small" :disabled="!eleForm.ContractStartTime"></el-input>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType!=9 && contractType!=10 && contractType!=13 && no!=22 && contractType">
          <el-date-picker type="date" placeholder="" v-model="eleForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间" v-if="contractType==13 ||  no==22">
          <el-input v-model="noDateTxt" style="width:200px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="试用期时长(月)" prop="TrialMonth" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
          <el-input type="number" v-model="eleForm.TrialMonth" style="width:200px" size="small" :disabled="!eleForm.TrialPeriodStartTime" @blur="getEndDate('eleForm')"></el-input>
        </el-form-item>
        <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 ||contractType == 2 ||contractType == 5 ||contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item :label="contractType==8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType==8 || contractType==9 || contractType==10">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract('eleForm')"></el-date-picker>
        </el-form-item>
        <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="contractType==8">
          <el-input v-model="eleForm.WorkingYear" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="contractType==8">
          <el-input v-model="eleForm.WorkingMonth" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="contractType==8">
          <el-input v-model="eleForm.WorkingDay" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="contractType==8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType==8 || contractType==9 || contractType==10">
          <el-date-picker type="date" placeholder="" v-model="eleForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-table :data="eleForm.list" class="doc_table" border max-height="300px" style="width:100%;">+
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">
              {{ scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PhoneNum" label="电话" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StrIdCard" label="身份证号码" :show-overflow-tooltip="true" align="center" min-width="150px">
          </el-table-column>
          <el-table-column prop="ObjName" label="项目名称" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="JobName" label="岗位" align="center" width="205px">
            <template slot-scope="{row}">
              <el-input v-model="row.JobName" size="small" clearable style="width:180px"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="DtEntryBdate" label="用工日期" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Bankcard" label="银行卡号" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DepositBank" label="开户银行" :show-overflow-tooltip="true" align="center">
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEleInfo = false" size="small">取消</el-button>
        <el-button type="primary" v-preventReClick size="small" @click="confirmToEle">去电子签约</el-button>
      </span>
    </el-dialog>

    <!-- 离职登记 -->
    <el-dialog title="离职登记" :visible.sync="showQuitSign" width="1100px">
      <el-table :data="multipleSelection" class="doc_table" v-loading="loading" style="width:100%" v-if="showQuitSign">
        <el-table-column label="序号" prop="No" min-width="60" align="center">
        </el-table-column>
        <el-table-column label="姓名" prop="Name" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="联系方式" prop="Tel" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="项目" prop="ProjectName" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="岗位" prop="JobName" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column label="*离职时间" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-date-picker v-model="quitList[$index].turnOverTime" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="*离职类型" min-width="160" align="center">
          <template slot-scope="{$index}">
            <el-select v-model="quitList[$index].strWorkState" placeholder="" size="mini" style="width:140px">
              <el-option label="正常离职" value="正常离职"></el-option>
              <el-option label="转正" value="转正"></el-option>
              <el-option label="自离" value="自离"></el-option>
              <el-option label="被辞退" value="被辞退"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="黑名单" min-width="150" align="center">
          <template slot-scope="{$index}">
            <el-select v-model="quitList[$index].isBlack" placeholder="" size="mini">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="备注" min-width="150" align="center">
          <template slot-scope="{$index}">
            <el-input v-model="quitList[$index].remark" size="small" clearable style="width:140px"></el-input>
          </template>
        </el-table-column>

      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQuitSign = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmQuit" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 打标签 -->
    <el-dialog title="打标签" :visible.sync="showTagging" width="700px">
      <div class="tagBox" v-if="TagList.length>0">
        <div class="dia_label_box">
          <el-checkbox-group v-model="wholeCheckList" @change="tagHandle">
            <el-checkbox v-for="(lab,index) in TagList" border :label="lab.Id" :key="index">
              <span>{{lab.TagName}}</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <!-- <div v-else>
        <el-empty style="height: 150px;" description="暂无标签">
          <el-button type="primary" size="small">+创建新标签</el-button>
        </el-empty>
      </div> -->
      <el-button type="primary" size="small" @click="addNewTag">+创建新标签</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTagging = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmTagging" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="创建新标签" :visible.sync="showAddNewTag" width="500px">
      <el-form label-width="100">
        <el-form-item label="标签名称:" prop="StrNativePlace">
          <el-input v-model="tagName" size="small" clearable style="width: 220px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddNewTag = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddNewTag" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="确认黑名单" :visible.sync="showBlack" width="500px">
      <el-form label-width="100">
        <el-form-item label="黑名单原因:" prop="StrNativePlace">
          <el-input v-model="reason" size="small" clearable style="width: 220px;"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBlack = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmBlack" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment';
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    e
  } from 'mathjs';
  export default {
    data() {
      var validatecard = (rule, value, callback) => {
        if (value.length != 18) {
          callback(new Error("身份证号码格式不正确"));
        } else {
          this.checkIdcard(value) ?
            callback() :
            callback(new Error("身份证号码格式不正确"));
        }
      };
      var validateTel = (rule, value, callback) => {
        if (value.toString().length != 11) {
          callback(new Error("手机号码格式不正确"));
        } else {
          callback();
        }
      };
      return {
        listQuery: {
          name: '',
          tel: '',
          begin: '',
          end: '',
          projectName:'',
          projectId:'',
          currpage: 1,
          pagecount: 10,
        },
        type: '',
        showPass: false,
        isBtnLoading: false,
        showDropScreen: -1,
        activeName: '待面试',
        tableData: [],
        roletype: localStorage.loginRoletype,
        multipleSelection: [],
        totalCount: 0,
        loading: false,
        isExping: false,
        showEntrySign: false,
        entryForm: {
          StrEmpName: "", //姓名
          StrIdCard: "", //身份证
          StrObjName: "", //项目名称
          StrPhoneNum: "", //联系方式
          DtEntryBdate: "", //用工之日
          StrDepName: "", //部门
          StrJobInf: "", //岗位
          StrPolitical: "", //政治面貌
          StrBlCmp: "", //商务主体
          DtIcCareEdate: "", //身份证有效终止时间
          StrNationClass: "", //民族
          StrNativePlace: "", //籍贯
          StrNativeAddr: "", //户籍地址
          StrAddr: "", //现住地址
          StrInsuranceType: "", //参保种类
          DtInsuranceDate: "", //参保日期
          StrMedicalCard: "", //医保卡号
          StrContractType: "", //合同协议类型
          DtContractBtime: "", //合同起始时间
          DtContractTime: "", //合同到期时间
          StrOther: "", //临时工
          StrPetype: "", //体检类型
          StrPeres: "", //体检结果
          StrBankName: "", //银行
          StrBankCard: "", //银行卡号
          Strremid7: "", //提前7天提醒
          Strremid30: "", //提前30天提醒
          Strremid60: "", //提前60天提醒
          StrRemark: "", //备注
          isOnlineSign: "", //是否线上签约
          attachUrl: "" //合同文件
        },
        Strremid: 7,
        entryRules: {
          StrEmpName: {
            required: true,
            message: '请输入身份证姓名',
            trigger: 'blur'
          },
          StrIdCard: {
            required: true,
            validator: validatecard,
            trigger: 'blur'
          },
          StrPhoneNum: {
            required: true,
            validator: validateTel,
            trigger: 'blur'
          },
          DtEntryBdate: {
            required: true,
            message: '请选择用工日期',
            trigger: 'change'
          },
          StrObjName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
        },
        politicsList: [], //政治面貌列表
        nationList: [], //民族列表
        contractTypeList: [], //合同协议类型
        projectList: [],
        isLongCheck: false,
        // 项目名称列表参数
        proNameQuery: {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        },
        impForm: {
          jobid: '',
          excelUrl: '',
        },
        // 自定义 级联选择props
        propPosition: {
          label: 'strParametername',
          value: 'strParameterid',
          children: 'children'
        },
        showImport: false,
        fileList: [],
        impRules: {
          excelUrl: {
            required: true,
            message: '请导入Excel',
            trigger: 'change'
          },
          jobid: {
            required: true,
            message: '请选择岗位',
            trigger: 'change'
          },
        },
        ContractTime: null,
        TempName: '', //签约模板
        eleForm: { //电子签约信息表单
          tempid: '', //模板id
          ObjName: '',
          ContractSubject: '', //员工签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          ContractStartTime: '', //合同开始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期开始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试用期时长
          ProtocolType: '', //合同/协议类型
          JobName: '', //岗位
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          Bankcard: '', //银行卡号
          DepositBank: '', //开户银行
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          StrEduLvl: '', //文化程度
          EmpContactAddress: '', //联系地址
          list: [{
            name: '',
            PhoneNum: '',
            StrIdCard: '',
            DtEntryBdate: '', //入职日期
            JobName: '', //岗位
            StrEduLvl: '', //文化程度
            ClientFullName: '',
            EmpContactAddress: '', //联系地址
            Bankcard: '', //银行卡号
            DepositBank: '', //开户银行
            Remark1: '',
            Remark2: '',
            Remark3: '',
          }], //选中的在职人员列表
        },
        tempEleList: [], //签约模板
        StrCustName: '',
        contractList: this.$store.state.EMP.contractList, //合同/协议列表
        legList: [], //主体列表
        contractType: null, //选择的合同类型
        no: '', //选择的合同no
        jobNameLabel: '',
        showEleInfo: false,
        eleRules: {
          tempid: {
            required: true,
            message: '请选择模板',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择员工签约主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请输入试用期时长',
            trigger: 'blur'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          JobName: {
            required: true,
            message: '请输入工作岗位（工种）',
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点（区域）',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          }
        },
        isDeling: false,
        showQuitSign: false,
        quitList: [],
        TagList: [], //标签列表
        showTagging: false,
        showAddNewTag: false,
        tagName: '',
        info: {},
        wholeCheckList: [], //选中的标签
        reason: '', //拉黑原因
        showBlack: false,
        handelList: [], //通过列表
        jobList: [],
        allJobList: [],
        // 意向岗位列表
        intendedPost: [],
        StrJobInf: '',
        StrJobInf2: '',
        permissionLists: [],
        // 按钮权限参数
        butQuery: {
          path: '/custEmp',
          powerEnName: 'custEmp'
        },
      }
    },
    created() {
      this.getList();
      this.getLegalSubjectList();
      this.getJobList();
      this.getButtonPower();
      this.getProNameList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (resmsg) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 获取项目列表
      getProNameList() {
        xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            this.projectList = res.data
          } else {
            this.projectList = []
          }
        })
      },
      currentChange(val) {
        this.listQuery.currpage = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1;
        this.listQuery.pagecount = val;
        this.getList();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      searchHandle() {
        this.listQuery.currpage = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        let pagename = this.activeName == '待面试' ? 'Interview' : this.activeName == '待入职' ? 'WaitEntry' : this.activeName == '在职' ? 'OnJob' : 'TurnOver';
        xz.Interview(this.listQuery, this.roletype, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.totalCount = res.count;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        this.getList();
      },
      //通过/未通过/未到面
      handelPass(type) {
        if (this.multipleSelection.length > 0) {
          this.type = type;
          this.handelList = [];
          this.multipleSelection.forEach(element => {
            if (type == '通过') {
              let d = {
                id: element.Id,
                DutyTime: ''
              }
              this.handelList.push(d)
            } else if (type == '未通过') {
              let d = {
                id: element.Id,
                StrRemark: ''
              }
              this.handelList.push(d)
            } else if (type == '未到面') {
              let d = {
                id: element.Id,
                StrRemark: '未到场'
              }
              this.handelList.push(d)
            }
          });
          this.showPass = true;
        } else {
          this.$message.warning('请至少勾选一位员工')
        }
      },
      confirmPass() {
        this.isBtnLoading = true;
        // let arr = [];
        // this.multipleSelection.forEach((element, index) => {
        //   arr.push({
        //     id: element.Id
        //   })
        //   if (index == this.multipleSelection.length - 1) {
        //     let data = {
        //       state: this.type,
        //       data: arr
        //     }
        //     xz.InterviewOption(data, this.roletype).then(res => {
        //       if (res.status == 'ok') {
        //         this.$message.success('操作成功');
        //         this.isBtnLoading = true;
        //         this.getList();
        //         this.showPass = false;
        //       } else {
        //         this.$message.error(res.msg);
        //         this.isBtnLoading = true;
        //       }
        //     })
        //   }
        // });
        let data = {
          state: this.type,
          data: this.handelList
        }
        xz.InterviewOption(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功');
            this.isBtnLoading = false;
            this.getList();
            this.showPass = false;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      //待面试导出
      expList(pagename) {
        let data = {
          name: this.listQuery.name,
          tel: this.listQuery.tel,
          begin: this.listQuery.begin,
          end: this.listQuery.end
        }
        this.isExping = true;
        xz.InterviewExcel(data, this.roletype, pagename).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = this.activeName + '列表.xls'; //这里写保存时的文件名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.isExping = false;
          } else {
            this.$message.warning(res.msg);
            this.isExping = false;
          }
        })
      },
      //参数列表（班次、坐班站班）
      getdictdatalistbyid(id) {
        xz.getdictdatalistbyid(id).then(res => {
          // console.log('getdictdatalistbyid', res)
          if (res.status == 'ok') {
            if (id == '253') {
              // 民族
              this.nationList = res.data.retList
            }
            if (id == '132') { // 黑名单标签
              this.blackLabelList = res.data.retList
            }
            if (id == '174') {
              // 合同协议类型
              this.contractTypeList = res.data.retList
            }
            if (id == '160') {
              // 政治面貌
              this.politicsList = res.data.retList
            }
          }
        })
      },
      entrySign() {
        if (this.politicsList.length == 0) {
          this.getProNameList()
          // 民族
          this.getdictdatalistbyid('253')
          // 合同协议类型
          this.getdictdatalistbyid('174')
          // 政治面貌
          this.getdictdatalistbyid('160')
          // 黑名单标签
          this.getdictdatalistbyid('132')
        }
        this.entryForm = {
          StrEmpName: "", //姓名
          StrIdCard: "", //身份证
          StrObjName: "", //项目名称
          StrPhoneNum: "", //联系方式
          DtEntryBdate: "", //用工之日
          StrDepName: "", //部门
          StrJobInf: "", //岗位
          StrPolitical: "", //政治面貌
          StrBlCmp: "", //商务主体
          DtIcCareEdate: "", //身份证有效终止时间
          StrNationClass: "", //民族
          StrNativePlace: "", //籍贯
          StrNativeAddr: "", //户籍地址
          StrAddr: "", //现住地址
          StrInsuranceType: "", //参保种类
          DtInsuranceDate: "", //参保日期
          StrMedicalCard: "", //医保卡号
          StrContractType: "", //合同协议类型
          DtContractBtime: "", //合同起始时间
          DtContractTime: "", //合同到期时间
          StrOther: "", //临时工
          StrPetype: "", //体检类型
          StrPeres: "", //体检结果
          StrBankName: "", //银行
          StrBankCard: "", //银行卡号
          Strremid7: "", //提前7天提醒
          Strremid30: "", //提前30天提醒
          Strremid60: "", //提前60天提醒
          StrRemark: "", //备注
          isOnlineSign: "", //是否线上签约
          attachUrl: "" //合同文件
        }
        this.type = 'sign';
        this.showEntrySign = true;
      },
      entryHandel(row) {
        this.$router.push({
          name: 'entryHandle',
          params: {
            jobName: row.JobName, //岗位名称
            Recruitdep: '', //招聘部门
            activeName: this.activeName,
            Recruitname: row.Servname, //招聘渠道 人员
            StrSource: row.StrSource, //招聘渠道
            JobType: '', //求职岗位类型 临时工 长期工
            StrIdCard: row.StrIdCard, //身份证
            Jobid: row.JobId, //岗位id
            JobCategory: '', //岗位名称
            Projectid: row.ProjectId, //项目id
            StrObjName: row.ProjectName, //项目名称
            ResumeId: row.ResumeId, //简历ID
            StrWorkAddress: '', //入职地点
            StrNationClass: '', //民族
            StrPhoneNum: row.Tel, //联系方式
            StrEmpName: row.Name, //姓名
            StrBlacklabel: '', //黑名单标签
            StrIsBlack: row.IsBlack, //是否黑名单
            type: 'custEmp',
            StrState: '入职' //当前状态
          }
        })
      },
      longChange(val) {
        if (val) {
          this.entryForm.DtIcCareEdate = ''
        }
      },
      //入职登记
      confirmEntrySign() {
        this.$refs.enterResumeForm.validate((valid) => {
          if (valid) {
            if (this.Strremid == 7) {
              this.entryForm.Strremid7 = '是';
              this.entryForm.Strremid30 = '';
            } else {
              this.entryForm.Strremid7 = '';
              this.entryForm.Strremid30 = '是';
            }
            if (this.isLongCheck) {
              this.entryForm.DtIcCareEdate = '2999-12-31'
            }
            this.isBtnLoading = true;
            xz.WaitEntryOption(this.entryForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.isBtnLoading = false;
                this.showEntrySign = false;
                this.getList();
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      // 身份证校验
      checkIdcard(val) {
        if (val.length != 18) {
          return false;
        } else {
          const idcode = val;
          const weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          const check_code = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2",
          ];
          const code = idcode + "";
          const last = idcode[17].toUpperCase(); // 最后一个
          const seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          const arr = seventeen.split("");
          const len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          // 格式的正则
          // 正则思路
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          return last === last_no && format == true;
        }
      },
      importEntryList() {
        this.fileList = [];
        this.impForm.excelUrl = '';
        this.showImport = true;
        if (this.allJobList.length == 0) {
          this.getPostList('')
        }
      },
      handleExceed() {
        this.$message.warning(`只能导入 1 个文件`);
      },
      // 删除
      handleFileRemove() {
        this.impForm.excelUrl = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.impForm.excelUrl = res;
          } else {
            this.impForm.excelUrl = ''
          }
        });
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20241017152021644.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "入职预登记导入模板.xlsx";
        aTag.click();
      },
      confirmImport() {
        if (this.impForm.excelUrl && this.impForm.jobid) {
          this.isBtnLoading = true;
          xz.WaitEntryImport(this.impForm, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功');
              this.isBtnLoading = false;
              this.showImport = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
              this.getList();
            }
          })
        } else if (!this.impForm.jobid) {
          this.$message.warning('请选择岗位')
        } else if (!this.impForm.excelUrl) {
          this.$message.warning('请导入Excel')
        }
      },
      changeTemp2(val) {
        console.log(val)
        this.tempName = val.TempName;
        this.eleForm.tempid = val.TempId;
      },
      //取签约主体列表
      getLegalSubjectList() {
        xz.getLegalSubjectList('', this.roletype).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data
          } else {
            this.legList = []
          }
        })
      },
      enterSignHandle() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          //判断是否选择了不同项目的人员
          let name = this.multipleSelection[0].ProjectName;
          let hasDifferent = this.multipleSelection.some(val => val.ProjectName != name)
          if (hasDifferent) {
            this.$message.warning('请选择同项目的人员')
          } else {
            this.clearEleForm();
            this.templatesByProjectList();
            let list = []
            this.multipleSelection.forEach((element, index) => {
              let data = {
                name: element.Name,
                ObjName: element.ProjectName,
                JobName: element.JobName,
                DtEntryBdate: element.DtEntryBdate,
                PhoneNum: element.Tel,
                StrIdCard: element.IdCard,
                EmergencyPhone: '',
                EmergencyContact: '',
                StrEduLvl: '',
                Bankcard: element.StrBankCard,
                DepositBank: element.StrBankName,
                EmpContactAddress: element.InterviewAddress //户籍地址
              }
              list.push(data)
              if (this.multipleSelection.length == index + 1) {
                this.$set(this.eleForm, 'list', list);
                // console.log(this.eleForm.list)
                this.eleForm.ObjName = this.multipleSelection[0].ProjectName
              }
            });
            this.showEleInfo = true;
          }
        }
      },
      //初始化电子签约信息表单
      clearEleForm() {
        this.tempType = '';
        this.StrCustName = '';
        this.eleForm = this.$options.data.call(this).eleForm
      },
      //根据项目查已配置好的模板列表
      templatesByProjectList() {
        xz.templatesByProjectList(this.multipleSelection[0].ProjectName, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.tempEleList = res.data.tempList;
            this.StrCustName = res.data.StrCustName;
          }
        })
      },
      //选择主体
      changeLeg(val, list) {
        if (val) {
          xz.getLegalSubjec(val).then(res => {
            if (res.status == 'ok') {
              this.$set(this[list], 'LegalPer', res.data.LegalPerson)
              this.$set(this[list], 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
            } else {
              this.$message.error('获取主体信息出错')
            }
          })
        } else {
          this.$set(this[list], 'LegalPer', '')
          this.$set(this[list], 'RegisterAddress', '')
        }
      },
      //选择合同/协议
      changeCont(val, list) {
        this[list].ProtocolType = val.name;
        this.contractType = val.val;
        this.jobNameLabel = val.jobNameLabel;
        this.no = val.no;
      },
      getEndDate(list) {
        this[list].TrialMonth = Number(this[list].TrialMonth)
        if (this[list].TrialMonth > 0 && Number.isInteger(this[list].TrialMonth)) {
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodStartTime).add(this[list].TrialMonth, 'months').format('YYYY-MM-DD');
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
        if (this[list].TrialMonth > 6) {
          this.$message.warning('当前试用期已超过6个月，请核对！');
        }
      },
      getContractEndDate(list) {
        if (this.ContractTime >= 1) {
          this[list].ContractEndTime = moment(this[list].ContractStartTime).add(this.ContractTime, 'years').format('YYYY-MM-DD');
          this[list].ContractEndTime = moment(this[list].ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
      },
      //计算工作时长
      changeTimeLaborContract(list) {
        let m1 = this[list].list[0].DtEntryBdate + ' 00:00:00';
        let m2 = this[list].TimeLaborContract + ' 00:00:00';
        let diff = moment.preciseDiff(m1, m2, true);
        console.log(diff)
        this[list].WorkingYear = diff.years;
        this[list].WorkingMonth = diff.months;
        this[list].WorkingDay = diff.days + 1;
      },
      confirmToEle() {
        this.$refs["eleForm"].validate((valid) => {
          if (valid) {
            xz.submitESigningInfo(this.eleForm, localStorage.loginRoletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！')
                this.getList()
                this.multipleSelection = []
              } else {
                this.$message.error(res.msg)
              }
              this.showEleInfo = false;
            })
          }
        })
      },
      //删除
      delEntry() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          this.isDeling = true;
          let arr = [];
          this.multipleSelection.forEach(element => {
            arr.push(element.Id)
          });
          let data = {
            id: arr.toString()
          }
          xz.WaitEntryDelete(data, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('删除成功！');
              this.isDeling = false;
              this.getList();
            } else {
              this.$message.error(res.msg);
              this.isDeling = false;
              this.getList();
            }
          })
        }
      },
      //离职登记
      quitSign() {
        if (this.multipleSelection.length == 0) {
          this.$message.warning('请至少选择一位人员')
        } else {
          this.quitList = [];
          this.multipleSelection.forEach(e => {
            let data = {
              strExcelPath: e.strExcelPath,
              intExcelLine: e.intExcelLine,
              strWorkState: '',
              isBlack: '',
              remark: '',
              turnOverTime: '',
              name: e.Name
            }
            this.quitList.push(data)
          });
          this.showQuitSign = true;
        }
      },
      confirmQuit() {
        let canQuit = true;
        this.quitList.forEach((e, index) => {
          if (!e.strWorkState || !e.turnOverTime) {
            // this.$message.warning('第'+ (index+1) + '行 离职时间、离职类型 未完善')
            canQuit = false
          }
          if (index == this.quitList.length - 1) {
            if (canQuit) {
              this.isBtnLoading = true;
              let d = {
                data: this.quitList
              }
              xz.Interview(d, this.roletype, 'OnJobOption').then(res => {
                if (res.status == 'ok') {
                  this.$message.success('离职操作成功！');
                  this.isBtnLoading = false;
                  this.showQuitSign = false;
                  this.getList();
                } else {
                  this.$message.error(res.msg);
                  this.isBtnLoading = false;
                }
              })
            } else {
              this.$message.warning('请完善离职信息')
            }
          }
        });
      },
      tagging(row) {
        if (this.TagList.length == 0) {
          this.getTagList();
        }
        this.info = row;
        if (row.TagList != null) {
          this.wholeCheckList = [];
          row.TagList.forEach(element => {
            this.wholeCheckList.push(element.Id)
          });
        } else {
          this.wholeCheckList = [];
        }
        this.showTagging = true;
      },
      getTagList() {
        xz.TagList('', this.roletype).then(res => {
          if (res.status === 'ok') {
            this.TagList = res.data;
          } else {
            this.TagList = []
          }
        })
      },
      confirmTagging() {
        this.isBtnLoading = true;
        let arr = [];
        this.wholeCheckList.forEach(element => {
          arr.push(element)
        });
        let data = {
          strExcelPath: this.info.strExcelPath,
          intExcelLine: this.info.intExcelLine,
          tagid: arr.toString(),
        }
        xz.Interview(data, this.roletype, 'EmpTag').then(res => {
          if (res.status == 'ok') {
            this.$message.success('添加标签成功！');
            this.isBtnLoading = false;
            this.showTagging = false;
            this.getList()
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      //新增标签
      addNewTag() {
        this.tagName = '';
        this.showAddNewTag = true;
      },
      confirmAddNewTag() {
        if (this.tagName) {
          let d = {
            tag: this.tagName
          }
          this.isBtnLoading = true;
          xz.Interview(d, this.roletype, 'CreateTag').then(res => {
            if (res.status == 'ok') {
              this.$message.success('新增标签成功');
              this.isBtnLoading = false;
              this.showAddNewTag = false;
              this.getTagList();
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      tagHandle(val) {
        console.log(val)
      },
      black(row) {
        this.reason = '';
        this.info = row;
        this.showBlack = true;
      },
      confirmBlack() {
        let d = {
          strExcelPath: this.info.strExcelPath,
          intExcelLine: this.info.intExcelLine,
          reason: this.reason
        }
        this.isBtnLoading = true;
        xz.Interview(d, this.roletype, 'AddBlack').then(res => {
          if (res.status == 'ok') {
            this.$message.success('拉黑成功');
            this.isBtnLoading = false;
            this.showBlack = false;
            this.getTagList();
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      // 选择项目
      proSearChange(val) {
        let obj = {};
        if (val) {
          this.entryForm.StrJobInf = '';
          obj = this.projectList.find((item) => {
            return item.StrprojectName === val;
          });
          if (this.allJobList.length == 0) {
            this.getPostList(obj.Projectid);
          } else {
            this.getJobList(obj.Projectid);
          }
        } else {
          this.jobList = [];
        }
      },
      // 获取岗位列表
      getPostList(projectid) {
        this.allJobList = [];
        this.jobList = [];
        xz.getresourcechangejoblist({
          'IsRAllocation': '1'
        }, localStorage.loginRoletype).then(res => {
          if (res.status == 'ok') {
            this.allJobList = res.data.retList;
            if (projectid) {
              this.getJobList(projectid)
            }
          } else {
            this.allJobList = [];
          }
        });
      },
      getJobList(projectid) {
        let resArr = this.allJobList;
        for (let i = 0; i < resArr.length; i++) {
          let element07 = resArr[i];
          if (element07.Projectid == projectid) {
            this.jobList.push({
              Id: element07.Id,
              CustomerJobName: element07.CustomerJobName
            });
          }
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
    margin-left: 15px;
  }

  .req {
    color: red;
    margin-right: 8px;
  }

  .dia_label_box {
    max-height: 400px;
    overflow-y: auto;
    margin-bottom: 20px;
  }
  .pro_down_box{
    padding-left: 15px;
  }
</style>
<style>
  .page_custEmp .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_custEmp .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_custEmp .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_custEmp .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_custEmp .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_custEmp .el-checkbox__label {
    padding-left: 3px;
  }

  .page_custEmp .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .dia_label_box .el-checkbox.is-bordered.is-checked,
  .dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #19BD92;
  }

  .dia_label_box .el-checkbox {
    border: 1px solid #ddd;
    padding: 2px 3px;
    border-radius: 3px;
    height: auto;
    margin: 5px 20px 0 0;
  }

  .p_resource_module .r_dropDownScreen .el-checkbox__label,
  .dia_label_box .el-checkbox__label {
    padding-left: 3px;
  }
</style>